import { Box, Button, Grid, InputBase, Modal, Typography, styled } from '@mui/material';
import React, { useState } from 'react';
import BoxInputs from 'src/components/Modals/ConfirmModals.js/BoxInputs';
import GridItems from 'src/components/Modals/ConfirmModals.js/GridItems';

function ConfirmForm({ handleCloseConfirm, handleSubmit }) {

    return (
        <div
            style={{
                position: 'absolute',
                maxWidth: '1000px',
                width: '80vw',
                maxHeight: '80vh',
                overflowY: 'auto',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'white',
                padding: '20px',
            }}
        >
            <Grid container spacing={2}>
                <GridItems title={'Client Name*'} value={'Kuldeep'} />
                <GridItems title={'Date Of Billing'} value={'23-05-2023'} />
                <GridItems title={'Service for'} value={'Men'} />
                <GridItems title={'Qty'} value={'1'} />
                <GridItems title={'Contact Number'} value={'9637xxx999'} />
                <GridItems title={'Times of Billing'} value={'11:00 AM'} />
                <GridItems title={'Select Service'} value={'Facial'} />
                <GridItems title={'Start end Time'} value={'11:00 To 11:30'} />
                <GridItems title={'Service Provider'} value={'Abhi'} />
                <GridItems title={'Price'} value={'500'} />
            </Grid>
            <BoxInputs title={'Subtotal'} />
            <BoxInputs title={'Discount'} />
            <BoxInputs title={'Taxes'} />
            <BoxInputs title={'Refferal Code'} />
            <BoxInputs title={'Total'} />
            <BoxInputs title={'Give Reward Points'} />
            <BoxInputs title={'Payment Dues'} />
            <BoxInputs title={'Appointment Status'} />
            <BoxInputs title={'Advance Given'} />
            <Box sx={{ py: 2, display: 'flex', gap: '1rem' }}>
                <Button onClick={handleCloseConfirm} variant="contained" color="error">
                    Cancel
                </Button>
                <Button onClick={handleSubmit} variant="contained" color="primary">
                    Create
                </Button>
            </Box>
        </div>
    );
}

export default ConfirmForm;